// extracted by mini-css-extract-plugin
module.exports = {"discountPercentageBadge":"DiscountStarBadge_discountPercentageBadge__iqAI8","text":"DiscountStarBadge_text__jAco2","background":"DiscountStarBadge_background__D56L_"};